import assign from 'lodash/assign';
import constants from '../constants';

import User from '../../models/User';

const initState = () =>
    assign({}, User(), {
        originalServerSideRequestCookies: {},
        ip: '',
        features: {
            canAccessAnalytics: false,
            canAccessBilling: false,
            canAccessContacts: false,
            canAccessMainAnalytics: false,
            canAccessMainContacts: false,
            canAccessMultiFamilyResources: false,
            canAccessUserManagement: false,
            canAddListing: false,
            canRespondToReview: false,
            canUpdateListing: false
        }
    });

const user = (state = initState(), action = {}) => {
    const { type, payload } = action;

    if (type === constants.UPDATE_USER_INFO) {
        state = assign({}, state, payload);

        return state;
    }
    return state;
};

export default user;
